import users, * as Users from './users';
import pages, * as Pages from './pages';
import loading, * as Loading from './loading';
import modals, * as Modals from './modals';
import timeStamp from './time-stamp';
import editing, * as Editing from './editing';

export default { users, pages, loading, modals, timeStamp, editing };
export { Users, Pages, Loading, Modals, Editing };



// WEBPACK FOOTER //
// ./src/reducers/index.js